<template>
  <page>
    <v-card>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.accmType" :label="labels.accmType" :error-messages="errors.collect('accmType')" data-vv-name="accmType" :data-vv-as="labels.accmType"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.accmTypeDesc" :label="labels.accmTypeDesc" :error-messages="errors.collect('accmTypeDesc')" data-vv-name="accmTypeDesc" :data-vv-as="labels.accmTypeDesc"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkGrpLblS" :label="labels.blkGrpLblS" :error-messages="errors.collect('blkGrpLblS')" data-vv-name="blkGrpLblS" :data-vv-as="labels.blkGrpLblS"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blksGrp1LblS" :label="labels.blksGrp1LblS" :error-messages="errors.collect('blksGrp1LblS')" data-vv-name="blksGrp1LblS" :data-vv-as="labels.blksGrp1LblS"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.blksGrp2LblS" :label="labels.blksGrp2LblS" :error-messages="errors.collect('blksGrp2LblS')" data-vv-name="blksGrp2LblS" :data-vv-as="labels.blksGrp2LblS"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.blkLblS" :label="labels.blkLblS" :error-messages="errors.collect('blkLblS')" data-vv-name="blkLblS" :data-vv-as="labels.blkLblS" v-validate="'name|max:8'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNewAccumType">
          New Accumulation Type
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
        <template v-slot:item="row"><tr>
          <td class="text-xs-left">{{ row.item.accmType }}</td>
          <td class="text-xs-left">{{ row.item.accmTypeDesc }}</td>
          <td class="text-xs-left">{{ row.item.blkGrpLblS }}</td>
          <td class="text-xs-left">{{ row.item.blksGrp1LblS }}</td>
          <td class="text-xs-left">{{ row.item.blksGrp2LblS }}</td>
          <td class="text-xs-left">{{ row.item.blkLblS }}</td>
          <td class="table-action-header">
            <table-action :rowData="row" query @query="doAccumTypeQuery(row.item.accmType)" review @review="doAccumTypeReview(row.item.accmType)" remove @remove="doPromptRemove(row.item)"></table-action>
          </td>
                        </tr></template>
      </v-data-table>
    </v-card>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure to delete the selected Accumulation Type {{ deleteAccumType }}?
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Accumulation Type', value: 'accmType' },
        { text: 'Description', value: 'accmTypeDesc' },
        { text: 'Block Group Label, Short', value: 'blkGrpLblS' },
        { text: 'Block Sub Group 1 Label, Short', value: 'blksGrp1LblS' },
        { text: 'Block Sub Group 2 Label, Short', value: 'blksGrp2LblS' },
        { text: 'Block Label, Short', value: 'blkLblS' },
        TableConst.tableActionHeader
      ],
      accumTypeForm: {
        accmType: null,
        accmTypeDesc: null,
        blkGrpLblS: null,
        blksGrp1LblS: null,
        blksGrp2LblS: null,
        blkLblS: null
      },
      labels: {
        accmType: 'Accumulation Type',
        accmTypeDesc: 'Description',
        blkGrpLblS: 'Block Group Label, Short',
        blksGrp1LblS: 'Block Sub Group 1 Label, Short',
        blksGrp2LblS: 'Block Sub Group 2 Label, Short',
        blkLblS: 'Block Label, Short'
      },
      filters: {
        accmType: undefined,
        accmTypeDesc: undefined,
        blkGrpLblS: undefined,
        blksGrp1LblS: undefined,
        blksGrp2LblS: undefined,
        blkLblS: undefined
      },
      totalItems: 0,
      promptRemove: false,
      loading: false,
      deleteAccumType: '',
      selectedAccmType: undefined,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.accumTypeList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((accumTypeMap) => {
                const convertList = {
                  accmType: accumTypeMap.accmType,
                  accmTypeDesc: accumTypeMap.accmTypeDesc,
                  blkGrpLblS: accumTypeMap.blkGrpLblS,
                  blksGrp1LblS: accumTypeMap.blksGrp1LblS,
                  blksGrp2LblS: accumTypeMap.blksGrp2LblS,
                  blkLblS: accumTypeMap.blkLblS
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
      /*
      const apiURI = this.menu.accumTypeList
      if (apiURI) {
        this.loading = true
        this.$http.get(apiURI).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(accumTypeMap => {
              const converList = {
                accmType: accumTypeMap.accmType,
                accmTypeDesc: accumTypeMap.accmTypeDesc,
                blkGrpLblS: accumTypeMap.blkGrpLblS,
                blksGrp1LblS: accumTypeMap.blksGrp1LblS,
                blksGrp2LblS: accumTypeMap.blksGrp2LblS,
                blkLblS: accumTypeMap.blkLblS
              }
              this.items.push(converList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
      */
    },
    doNewAccumType(modeAccumType) {
      this.$router.push({ name: 'accumTypeReview', params: { accumTypeReviewParam: 'New', modeAccumType: 'Create' } })
    },
    doAccumTypeReview(accumTypeReviewParam, modeAccumType) {
      this.$router.push({ name: 'accumTypeReview', params: { accumTypeReviewParam: accumTypeReviewParam, modeAccumType: 'Review' } })
    },
    doAccumTypeQuery(accumTypeReviewParam, modeAccumType) {
      this.$router.push({ name: 'accumTypeReview', params: { accumTypeReviewParam: accumTypeReviewParam, modeAccumType: 'Query' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedAccmType = data
        this.deleteAccumType = data.accmType
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteAccumType
      if (apiURI) {
        const expand = this.selectedAccmType
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.accmType = undefined
      this.filters.accmTypeDesc = undefined
      this.filters.blkGrpLblS = undefined
      this.filters.blksGrp1LblS = undefined
      this.filters.blkLblS = undefined
      this.filters.blksGrp2LblS = undefined
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.accumTypeParam.menu
    }
  },
  created() {
    this.doInit(true)
  },
  mounted() {},
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
